import { API } from '@/shared/api/modules';
import type { GetFacilityLevelsOfCareRatesAndRevenueRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getFacilityRatesAndRevenueQueryOptions = (
  params: GetFacilityLevelsOfCareRatesAndRevenueRequestDto
) =>
  queryOptions({
    queryKey: ['facility-levels-of-care-rates-and-revenue', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getFacilityLocRatesAndRevenue(params, { signal }),
    placeholderData: keepPreviousData,
  });
